package com.exura.features.planConstruction

import com.exura.features.localization.domain.model.BasicLangSet
import com.exura.features.localization.domain.model.Language
import com.exura.features.localization.domain.model.Localization

interface PlanConstructionLang {
    val toggles: Toggles

    interface Toggles {
        val layoutModeView: String
        val layoutModeEdit: String
        val viewModeText: String
        val viewModeGraphics: String
    }
}

data object PlanConstructionPolish : PlanConstructionLang {
    override val toggles = Toggles
    data object Toggles : PlanConstructionLang.Toggles {
        override val layoutModeView: String = "Podgląd"
        override val layoutModeEdit: String = "Edycja"
        override val viewModeText: String = "Tekst"
        override val viewModeGraphics: String = "Grafika"

    }
}

data object PlanConstructionEnglish : PlanConstructionLang {
    override val toggles = Toggles
    data object Toggles : PlanConstructionLang.Toggles {
        override val layoutModeView: String = "View"
        override val layoutModeEdit: String = "Edit"
        override val viewModeText: String = "Text"
        override val viewModeGraphics: String = "Graphics"
    }
}

private val planConstructionLangSet = BasicLangSet<PlanConstructionLang>(
    mapOf(
        Language.POLISH to PlanConstructionPolish,
        Language.ENGLISH to PlanConstructionEnglish,
    )
)

val planConstructionLocalization = Localization<PlanConstructionLang>(planConstructionLangSet)
